// Import constants
import { PRIVACY_POLICY_URL } from '../constants/links';

// Import components
import SeoHead from '../components/seo/SeoHead';
import StickyNavbar from '../components/navbar/StickyNavbar';

export default function PrivacyPolicy() {
  return (
    <div className="w-full min-h-screen bg-white text-gray-800 flex flex-col">
      <SeoHead route="/privacy" />
      <StickyNavbar />

      <main className="flex flex-col flex-1 py-4">
        <h1 className="sr-only">Privacy Policy</h1>
        <iframe
          className="flex-1"
          src={PRIVACY_POLICY_URL}
          title="WhenWeMeet Privacy Policy"
        />
      </main>
    </div>
  );
}
